import { Directive, HostListener, Input, ElementRef } from '@angular/core';
import {
  NG_VALUE_ACCESSOR, ControlValueAccessor
} from '@angular/forms';

@Directive({
  selector: '[phoneMask]',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: PhoneMaskDirective,
    multi: true
  }]
})
export class PhoneMaskDirective implements ControlValueAccessor {
  constructor(private el: ElementRef) { }

  onTouched: any;
  onChange: any;

  @Input('phoneMask') PhoneMask: string;

  writeValue(initValue: any): void {
    setTimeout(() => {
      this.el.nativeElement.value = initValue;
    }, 50);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  @HostListener('blur')
  onblur() {
    this.onTouched(true);
  }

  @HostListener('keyup', ['$event'])
  onKeyup($event: any) {
    this.onkeypress($event);
    var Value = $event.target.value.replace(/\D/g, '');
    var pad = this.PhoneMask.replace(/\D/g, '').replace(/9/g, '_');
    var valueMask = Value + pad.substring(0, pad.length - Value.length);
    if ($event.keyCode === 8) {
      this.onChange(Value);
      if ($event.target.value.length == 8 || $event.target.value.length == 3 || $event.target.value.length == 0) {
        return;
      }
    } else if ($event.keyCode === 13 || $event.keyCode === 32) {
      this.onChange(Value);
      return;
    }

    if (Value.length <= pad.length) {
      this.onChange(Value);
    }

    var valueMaskPos = 0;
    Value = '';
    for (var i = 0; i < this.PhoneMask.length; i++) {
      if (isNaN(parseInt(this.PhoneMask.charAt(i)))) {
        Value += this.PhoneMask.charAt(i);
      }
      else {
        Value += valueMask[valueMaskPos++];

      }
    }

    if (Value.indexOf('_') > -1) {
      Value = Value.substr(0, Value.indexOf('_'));
    }
    this.onChange(Value);
    $event.target.value = Value;
    this.onTouched(true);
  }

  @HostListener('keypress', ['$event'])
  onkeypress($event: any) {
    var Value = $event.target.value.replace(/\D/g, '');
    if (Value.length < 11) {
      this.PhoneMask = '(99)9999-9999';

    } else {
      this.PhoneMask = '(99)99999-9999';
    }
  }
}
